import { render } from "./VetDirectory.vue?vue&type=template&id=138fb012&scoped=true"
import script from "./VetDirectory.vue?vue&type=script&lang=js"
export * from "./VetDirectory.vue?vue&type=script&lang=js"

import "./VetDirectory.vue?vue&type=style&index=0&id=138fb012&lang=css"
import "./VetDirectory.vue?vue&type=style&index=1&id=138fb012&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138fb012"]])

export default __exports__